// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
//import Vuex from 'vuex'
import App from './App'
import router from './router'
import store from './store/index'

//Vue.use(Vuex)
/*Vue.config.errorHandler = (err, vm, info) => {
  console.log("pinche error");
};*/

/*Bootstrap*/
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

/*Style Calendar y App*/
import './assets/css/app.css';
//import './assets/css/style.css';
//import './assets/css/fullcalendar.bundle.css'

/*Element Ui*/
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/es'
Vue.use(ElementUI, { locale })

/*Axios*/
window.axios = require('axios');

/*Moments*/
const moment = require('moment')
require('moment/locale/es')
Vue.use(require('vue-moment'),{moment});

/*Google Analytics */
import VueAnalytics from 'vue-analytics';
Vue.use(VueAnalytics, {
  id: 'G-FNP6KQLJJR',
  router
});


Vue.config.productionTip = false



/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js